import { OfferTypeEnum } from '@makemydeal/dr-platform-types';
import type { ScenarioVehicleDetail } from '@makemydeal/dr-dash-types';
import { formatDollarsAndCents, capitalize } from '@makemydeal/dr-common-utils';
import { MONEY_FACTOR_TYPE } from '../constants';

export const formatVehicleYMMT = (detail: ScenarioVehicleDetail): string => {
    return [detail.year, detail.make, detail.model, detail.trim].filter(Boolean).join(' ');
};

export const formatPaymentDetails = ({ offerType, term, monthlyPayment, rate, rateType }: ScenarioVehicleDetail): string => {
    const label = capitalize(offerType!);
    if (offerType === OfferTypeEnum.CASH) {
        return label;
    }

    const offerLabel = term ? `${label} ${term}` : label;
    const paymentFormatted = Number.isFinite(monthlyPayment) ? `${formatDollarsAndCents(monthlyPayment)}/mo` : '';
    const rateFormatted = Number.isFinite(rate) ? (rateType === MONEY_FACTOR_TYPE ? `${rate} MF` : `${rate}%APR`) : '';
    const details = [paymentFormatted, rateFormatted].filter(Boolean).join(' - ');

    return details ? `${offerLabel}, ${details}` : offerLabel;
};
